/**
 * Mixpanel's `element` name per menu slot. Deliberately unrelated to the menu type the backend sends:
 * analytics named these before the domain did, and the existing dashboards depend on these exact values.
 */
const MENU_TRACKING_ELEMENTS = {
  food: 'main_menu',
  drinks: 'drinks_menu',
  christmas: 'festive_menu',
};

const trackMenuEvent = ({ element, elementValue = null, interaction }) => {
  App.track.event('room_page_interaction', {
    section: 'offers_and_packages',
    element,
    element_value: elementValue,
    interaction,
  });
};

const trackMenusOnceVisible = (cards) => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);

      const trackingElement = MENU_TRACKING_ELEMENTS[entry.target.dataset.menuType];
      if (!trackingElement) return;

      trackMenuEvent({ element: 'menu', elementValue: trackingElement, interaction: 'visible' });
    });
  }, { threshold: 0.2 });

  cards.forEach(card => observer.observe(card));
};

const hideThumbnailsThatFailedToLoad = () => {
  document.querySelectorAll('.js-menu-thumbnail-image').forEach((image) => {
    if (image.complete && image.naturalWidth === 0) {
      image.classList.add('hidden');
      return;
    }

    image.addEventListener('error', () => image.classList.add('hidden'), { once: true });
  });
};

export const initMenu = () => {
  hideThumbnailsThatFailedToLoad();

  const cards = document.querySelectorAll('.js-menu-thumbnail');
  if (!cards.length) return;

  trackMenusOnceVisible(cards);

  cards.forEach((card) => {
    card.addEventListener('click', (event) => {
      const trackingElement = MENU_TRACKING_ELEMENTS[card.dataset.menuType];
      if (trackingElement) {
        trackMenuEvent({ element: trackingElement, interaction: 'click' });
      }

      // The href stays a real link so the menu remains crawlable and middle-clickable; the modal only
      // takes over when it is actually mounted.
      if (!window.triggerShowRoomMenuModal) return;

      // Browsers that cannot embed a PDF (e.g. Android Chrome) follow the link and open it in a new tab.
      if (!navigator.pdfViewerEnabled) return;

      event.preventDefault();
      window.triggerShowRoomMenuModal({
        name: card.dataset.name,
        pdf: card.href,
        img: card.dataset.img,
        trackingElement,
      });
    });
  });
};
